import type { ImagePlanSlot, Market } from "../types/workspace";

export const MARKETS: Market[] = [
  {
    id: "tw",
    label: "台灣",
    flag: "🇹🇼",
    platforms: [
      { id: "shopee-tw", name: "Shopee Taiwan 蝦皮", marketId: "tw" },
      { id: "momo", name: "momo 購物網", marketId: "tw" },
      { id: "pchome", name: "PChome 24h", marketId: "tw" }
    ]
  },
  {
    id: "jp",
    label: "日本",
    flag: "🇯🇵",
    platforms: [
      { id: "amazon-jp", name: "Amazon.co.jp", marketId: "jp" },
      { id: "rakuten", name: "Rakuten Ichiba 樂天市場", marketId: "jp" },
      { id: "yahoo-jp", name: "Yahoo! Shopping Japan", marketId: "jp" },
      { id: "qoo10", name: "Qoo10", marketId: "jp" }
    ]
  },
  {
    id: "cn",
    label: "中國",
    flag: "🇨🇳",
    platforms: [
      { id: "taobao", name: "Taobao 淘寶", marketId: "cn" },
      { id: "tmall", name: "Tmall 天貓", marketId: "cn" },
      { id: "jd", name: "JD 京東", marketId: "cn" },
      { id: "pdd", name: "Pinduoduo 拼多多", marketId: "cn" },
      { id: "douyin", name: "Douyin 抖音電商", marketId: "cn" }
    ]
  },
  {
    id: "hk",
    label: "香港",
    flag: "🇭🇰",
    platforms: [
      { id: "hktvmall", name: "HKTVmall", marketId: "hk" },
      { id: "taobao-hk", name: "Taobao Hong Kong 淘寶香港", marketId: "hk" },
      { id: "carousell-hk", name: "Carousell Hong Kong", marketId: "hk" }
    ]
  }
];

const defaults: Array<Pick<ImagePlanSlot, "purpose" | "direction" | "rationale">> = [
  { purpose: "商品主圖", direction: "Clean Studio", rationale: "第一眼就辨識到商品" },
  { purpose: "質感形象圖", direction: "Premium", rationale: "建立品牌質感與信任" },
  { purpose: "生活情境圖", direction: "Lifestyle", rationale: "讓客戶看見使用情境" },
  { purpose: "細節特寫圖", direction: "Macro Detail", rationale: "呈現材質與做工" },
  { purpose: "核心賣點圖", direction: "Feature Focus", rationale: "快速傳達主要好處" },
  { purpose: "功能解說圖", direction: "Explainer", rationale: "把功能說清楚" },
  { purpose: "使用場景圖", direction: "Use Case", rationale: "連結顧客需要" },
  { purpose: "配件展示圖", direction: "Included Items", rationale: "清楚交代購買內容" },
  { purpose: "尺寸規格圖", direction: "Specification", rationale: "降低購買不確定感" },
  { purpose: "品牌故事圖", direction: "Brand Story", rationale: "創造情感差異" }
];

export const DEFAULT_IMAGE_PLAN: ImagePlanSlot[] = defaults.map((slot, index) => ({
  ...slot,
  id: `slot-${String(index + 1).padStart(2, "0")}`,
  number: index + 1,
  enabled: true,
  note: "",
  preserve: { shape: true, logo: true, colours: true, packaging: false }
}));
